import { LoadCardsRequestAction, LoadCardsSuccessAction, LoadCardsErrorAction } from './actions.d';
import actionsTypes from './actionTypes';
import { ILoadDataRequestPayload, ILoadDataSuccessPayload } from './types.d';

const actions = {
  loadCreditsRequest: <T1, T2>(payload: ILoadDataRequestPayload<T1, T2>): LoadCardsRequestAction<T1, T2> => ({
    type: actionsTypes.LOAD_CREDITS_REQUEST,
    payload,
  }),

  loadCreditsSuccess: (payload: ILoadDataSuccessPayload): LoadCardsSuccessAction => ({
    type: actionsTypes.LOAD_CREDITS_SUCCESS,
    payload,
  }),

  loadCreditsError: (): LoadCardsErrorAction => ({
    type: actionsTypes.LOAD_CREDITS_ERROR,
  }),
};

export default actions;
